module.exports = __webpack_public_path__ + "static/media/s_10.285a4bac.mp3";